import { Account } from "src/app/common/services/accounts/accounts.interface";

/**
 * From Server API
 */
export interface MultiCardAccount {
  maskedCardNumber: string;
  active: boolean;
  blocked: boolean;
}

export interface MultiCardChangeStatusBean {
  cardNumber: string;
  action: MultiCardAction;
  accountKeyStr: string;
}

export interface MultiCardActivateWithPinBean {
  cardNumber: string;
  action: MultiCardAction;
  accountKeyStr: string;
  activationPIN: string;
  newPIN: string;
}

export interface MultiCardChangePinBean {
  cardNumber: string;
  action: MultiCardAction;
  accountKeyStr: string;
  oldPIN: string;
  newPIN: string;
}

/**
 * For UI
 */
export interface MultiCardData {
  maskedCardNumber: string;
  asteriskCardNumber: string;
  active: boolean;
  blocked: boolean;
  cardType: MultiCardType;
  account: Account | null;
  actions: MultiCardActionButton[];
  actionSelected?: MultiCardActionButton;
}

export enum MultiCardType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT'
}

/**
 * Available Actions
 */
export enum MultiCardAction {
  ACTIVATE = 'ACTIVATE',
  ACTIVATE_BY_PIN = 'ACTIVATE_BY_PIN',
  BLOCK = 'BLOCK',
  UNBLOCK = 'UNBLOCK',
  CHANGE_PIN = 'CHANGE_PIN'
}

export interface MultiCardActionButton {
  label: string;
  type: MultiCardAction;
}